import { queryOptions } from '@tanstack/react-query';

import * as proposalsApi from './proposals.api';

export const proposalKeys = {
  all: ['proposals'] as const,
  resources: () => [...proposalKeys.all, 'resources'] as const,
};

export const proposalQueries = {
  /** The proposal-only spaces: rate, capacity, minimum duration and weekly hours. */
  resources: () =>
    queryOptions({
      queryKey: proposalKeys.resources(),
      queryFn: proposalsApi.listProposalResources,
      staleTime: 5 * 60_000,
    }),
};
